export default "__VITE_ASSET__3fd67171__"